import React from 'react';

export interface INodeIndexProps {
    className?: string;
}

export const NoIndex: React.FC<INodeIndexProps> = (props) => (
    <span className={props.className}>
        <span dangerouslySetInnerHTML={{ __html: '<!--noindex-->' }} />
        {props.children}
        <span dangerouslySetInnerHTML={{ __html: '<!--/noindex-->' }} />
    </span>
);
